import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';

import TextField from '@mui/material/TextField';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import SearchIcon from '@mui/icons-material/Search';
import IconButton from '@mui/material/IconButton';
import CircularProgress from '@mui/material/CircularProgress';

import FournisseurGestionAutocomplete from 'components/Shared/FournisseurGestionAutocomplete';

const styles = theme => ({
    root: {
        display: 'flex',
        flexFlow: 'row wrap'
    },
    row: {
        flexBasis: '100%'
    },
    radioGroup: {
        flexFlow: 'row wrap',
        flexBasis: '100%'
    },
    columnLarge: {
        float: 'left',
        width: '40%',
        paddingRight: 10,
        paddingBottom: 10
    },
    columnMedium: {
        float: 'left',
        width: '23%',
        paddingRight: 10,
        paddingBottom: 10
    },
    columnSmall: {
        float: 'left',
        width: '12%',
        paddingRight: 10,
        paddingBottom: 10
    }
});

class PieceGestionSearchFilter extends React.Component {

    handleSearch = () => {
        this.props.onSearch();
    }

    handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            this.props.onSearch();
        }
    };

    renderSearchButton() {
        const { isLoading } = this.props;

        return (
            <IconButton
                aria-label="Rechercher"
                onClick={this.handleSearch}
                size="large"
                disabled={isLoading}
            >
                {isLoading ? <CircularProgress size={24} /> : <SearchIcon />}
            </IconButton>
        );
    }

    renderCriteres() {
        const { classes, criteres, onChange, isLoading } = this.props;

        if (criteres.typeRecherche === 'piece') {
            return (
                <div className={classes.row}>
                    <div className={classes.columnMedium}>
                        <TextField
                            fullWidth
                            id="numero-piece"
                            name="numeroPiece"
                            label="Pièce"
                            placeholder="Numéro de pièce"
                            onChange={onChange}
                            onKeyDown={this.handleKeyDown}
                            value={criteres.numeroPiece}
                            disabled={isLoading}
                            InputLabelProps={{
                                shrink: true
                            }}
                            // autoFocus
                        />
                    </div>
                    {this.renderSearchButton()}
                </div>
            );
        }
        else {
            return (
                <div className={classes.row}>
                    <div className={classes.columnMedium}>
                        <TextField
                            fullWidth
                            id="reference-commande"
                            name="referenceCommande"
                            label="Référence commande"
                            placeholder="Référence de commande"
                            onChange={onChange}
                            value={criteres.referenceCommande}
                            disabled={isLoading}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </div>
                    <div className={classes.columnSmall}>
                        <TextField
                            fullWidth
                            id="date-debut"
                            name="dateDebut"
                            label="Date de début"
                            placeholder="Date de création ou d'expédition"
                            type="date"
                            onChange={onChange}
                            value={criteres.dateDebut}
                            disabled={isLoading}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </div>
                    <div className={classes.columnSmall}>
                        <TextField
                            fullWidth
                            id="date-fin"
                            name="dateFin"
                            label="Date de fin"
                            placeholder="Date de création ou d'expédition"
                            type="date"
                            onChange={onChange}
                            value={criteres.dateFin}
                            disabled={isLoading}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </div>
                    <div className={classes.columnMedium}>
                        <TextField
                            fullWidth
                            id="article"
                            name="article"
                            label="Article"
                            placeholder="Code article"
                            onChange={onChange}
                            value={criteres.article}
                            disabled={isLoading}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </div>


                    <div className={classes.columnMedium}>

                        <FournisseurGestionAutocomplete
                            onChange={fournisseur => { let event = { target: { name: "codeFournisseur", value: fournisseur ? fournisseur.code : '' } }; onChange(event); }}
                            withConditionsSAVGenerales={false}
                            disabled={isLoading}
                        />
                    </div>

                    {this.renderSearchButton()}
                </div>
            );
        }
    }

    isSelected = numeroPiece => this.state.selectedPiece === numeroPiece;

    render() {
        const { classes, onChange, criteres, isLoading } = this.props;

        return (
            <div className={classes.root}>
                <div className={classes.row}>
                    <RadioGroup
                        className={classes.radioGroup}
                        name="typeRecherche"
                        value={criteres.typeRecherche}
                        onChange={onChange}>
                        <FormControlLabel value="piece" control={<Radio />} label="Vous connaissez la pièce" disabled={isLoading} />
                        <FormControlLabel value="no-piece" control={<Radio />} label="Vous ne connaissez pas la pièce" disabled={isLoading} />
                    </RadioGroup>
                </div>
                {
                    this.renderCriteres()
                }
            </div>
        );
    }
}

PieceGestionSearchFilter.propTypes = {
    criteres: PropTypes.object.isRequired,
    onSearch: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    client: PropTypes.object,
    isLoading: PropTypes.bool
};

PieceGestionSearchFilter.defaultProps = {
    isLoading: false
};

export default withStyles(styles)(PieceGestionSearchFilter);